module.exports = "/_next/static/images/construction-0046e364d8a1f212c28c988cb3d94814.webp";